module.exports = __webpack_public_path__ + "img/45_6.dc205ee0.png";